import React from 'react';

const SwipeIcon = ({ className = '', width = 38, height = 42 }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 38 42"
      className={className}
      width={width}
      height={height}
      fill="none"
    >
      <path
        d="M31.632 26.0418L24.1337 22.3018C23.6203 22.0452 23.0703 21.9168 22.502 21.9168H20.8337V10.9168C20.8337 9.39516 19.6053 8.16683 18.0837 8.16683C16.562 8.16683 15.3337 9.39516 15.3337 10.9168V30.6068L9.37533 29.2502C8.77032 29.1218 8.12866 29.3052 7.68866 29.7635L6.16699 31.3035L14.4903 40.0852C15.187 40.7818 16.5803 41.1668 17.552 41.1668H28.8453C30.6787 41.1668 32.2187 39.8285 32.4753 38.0135L33.6303 29.8368C33.8503 28.2785 33.0437 26.7568 31.632 26.0418Z"
        fill="white"
      />
      <path
        d="M33.9053 6.09516C31.2653 2.9785 25.6003 0.833496 19.0003 0.833496C12.4003 0.833496 6.73533 2.9785 4.09533 6.09516L0.666992 2.66683V11.8335H9.83366L6.03866 8.0385C7.87199 5.6735 12.822 3.5835 19.0003 3.5835C25.1787 3.5835 30.1287 5.6735 31.962 8.0385L28.167 11.8335H37.3337V2.66683L33.9053 6.09516Z"
        fill="white"
      />
    </svg>
  );
};

export default SwipeIcon;
